var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcoCloudServices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 12.6666H5.99994C5.13452 12.6664 4.28621 12.4255 3.54979 11.9709C2.81338 11.5163 2.21789 10.8659 1.82986 10.0923C1.44183 9.31877 1.27654 8.45255 1.35247 7.59047C1.4284 6.72838 1.74256 5.90439 2.25984 5.21057C2.77712 4.51676 3.47714 3.98045 4.28168 3.66158C5.08622 3.34271 5.96357 3.25384 6.81571 3.4049C7.66785 3.55596 8.4612 3.941 9.1071 4.51699C9.753 5.09298 10.226 5.83724 10.4733 6.66659H11.6666C12.4623 6.66659 13.2253 6.98266 13.7879 7.54527C14.3505 8.10788 14.6666 8.87094 14.6666 9.66659C14.6666 10.4622 14.3505 11.2253 13.7879 11.7879C13.2253 12.3505 12.4623 12.6666 11.6666 12.6666Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoCloudServices);
export default __webpack_public_path__ + "static/media/eco-cloud-services.bd1cb7fed8654151965c03ffb782351c.svg";
export { ForwardRef as ReactComponent };